import React from 'react';
import { styled } from '@mui/material/styles';
import {
  Container,
} from '@mui/material';
import GlobeGl from "../../components/globe/GlobeGl";

const PREFIX = 'Dashboard';

const classes = {
  dashboard: `${PREFIX}-dashboard`,
};

const StyledDiv = styled('div')(() => ({
  [`&.${classes.dashboard}`]: {
    marginBottom: '3rem',
  },
}));

const Dashboard = () => {
  return (
    <StyledDiv>
      <Container disableGutters className={classes.dashboard}>
        <GlobeGl />
      </Container>
    </StyledDiv>
  );
}

export default Dashboard;
